module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"message":"This space will show privacy policy"},"ja":{"message":"ここにプライバシーポリシーが表示されます"}}')
  delete Component.options._Ctor
}
